import { createContext } from 'react';

export const PermissionContext = createContext(false);
